<template>
  <div class="apply-detail-page">
    <apply-detail
      v-if="applyId"
      :apply-id="applyId"
      :can-approve="false"
    />
    <div v-else class="error-state">
      <el-empty description="缺少申请ID参数" />
      <el-button type="primary" @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import ApplyDetail from '../components/ApplyDetail.vue';

export default {
  name: 'ApplyDetailPage',
  
  components: {
    ApplyDetail
  },
  
  computed: {
    applyId() {
      const id = this.$route.query.applyId;
      return id ? parseInt(id) : null;
    }
  },
  
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.apply-detail-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.error-state {
  text-align: center;
  padding: 60px 0;
}
</style>
